import { render, staticRenderFns } from "./cadfiliais.vue?vue&type=template&id=2504d8f8&"
import script from "./cadfiliais.vue?vue&type=script&lang=js&"
export * from "./cadfiliais.vue?vue&type=script&lang=js&"
import style0 from "./cadfiliais.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports